import React from 'react';

import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import { Button, ButtonGroup, Tooltip } from '@mui/material';
import VerticalAlignTopIcon from '@mui/icons-material/VerticalAlignTop';
import VerticalAlignCenterIcon from '@mui/icons-material/VerticalAlignCenter';
import VerticalAlignBottomIcon from '@mui/icons-material/VerticalAlignBottom';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import TextRotationNoneIcon from '@mui/icons-material/TextRotationNone';
import TextRotationDownIcon from '@mui/icons-material/TextRotationDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

const AlignStyle = ({ propKey = 'vAlign', options = [] }) => {
  const { t } = useTranslation();

  const {
    actions: { setProp },
    vAlign,
  } = useNode(({ data: { props } }) => {
    return {
      vAlign: props[propKey],
    };
  });

  const onClick = (event) => {
    setProp((props) => {
      props[propKey] = event?.currentTarget?.name;
    }, 500);
  };

  const renderIcon = (iconName) => {
    switch (iconName) {
      case 'top':
        return <VerticalAlignTopIcon />;
      case 'center':
        return <VerticalAlignCenterIcon />;
      case 'bottom':
        return <VerticalAlignBottomIcon />;
      case 'left':
        return <FormatAlignLeftIcon />;
      case 'center-h':
        return <FormatAlignCenterIcon />;
      case 'right':
        return <FormatAlignRightIcon />;
      case 'justify':
        return <FormatAlignJustifyIcon />;
      case 'display-horizontal':
        return <TextRotationNoneIcon />;
      case 'display-vertical':
        return <TextRotationDownIcon />;
      case 'normal-order':
        return <TrendingFlatIcon />;
      case 'reverse-order':
        return <TrendingFlatIcon sx={{ transform: 'rotate(180deg)' }} />;
      case 'normal-order-v':
        return <TrendingFlatIcon sx={{ transform: 'rotate(90deg)' }} />;
      case 'reverse-order-v':
        return <TrendingFlatIcon sx={{ transform: 'rotate(270deg)' }} />;
      default:
        return '';
    }
  };

  return (
    <div style={{ display: 'block' }}>
      <ButtonGroup
        disableElevation
        sx={{ border: 'none' }}
        aria-label='Basic button group'
        size='small'
      >
        {options.map((option) => (
          <Tooltip key={option.name} title={t(option.label)}>
            <Button
              name={option.name}
              onClick={onClick}
              sx={(theme) => ({
                p: 1,
                '& span': {
                  m: 0,
                },
                backgroundColor: theme.palette.secondary.light,
                color:
                  vAlign === option.name
                    ? theme.palette.secondary.dark
                    : theme.common.buttonInactive,
                border: `none`,
              })}
              startIcon={renderIcon(option.iconName)}
            />
          </Tooltip>
        ))}
      </ButtonGroup>
    </div>
  );
};

export default AlignStyle;
